module.exports = __webpack_public_path__ + "static/media/lobby.500c799f.jpg";